import { render } from "./VoucherBasket.vue?vue&type=template&id=db5fca80&scoped=true"
import script from "./VoucherBasket.vue?vue&type=script&lang=js"
export * from "./VoucherBasket.vue?vue&type=script&lang=js"

import "./VoucherBasket.vue?vue&type=style&index=0&id=db5fca80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db5fca80"]])

export default __exports__